<template>
    <div>
        <div class="md:flex">
            <div class="mb-4 md:mb-0 md:w-2/3 flex-grow">
                <div class="flex justify-between items-center mb-4">
                    <h2 class="font-bold text-gray-800 leading-tight">
                        <span v-if="$page.props.active_trial">Trial Account</span>
                        <span v-if="$page.props.subscribed">Your Plan</span>

                        <span v-if="daysLeft" class="text-sm ml-2 text-gray-700 font-normal">{{ daysLeft }}</span>
                    </h2>

                    <jet-button 
                        :text="cycleUsePercentage < 80"
                        :primary="cycleUsePercentage >= 80 && cycleUsePercentage < 100"
                        :danger="cycleUsePercentage >= 100"
                        :class="{ 'bg-gray-200': cycleUsePercentage < 80 }"
                        class="ml-2"
                        v-if="!$page.props.active_trial && $page.props.is_admin"
                    >
                        <Link :href="route('subscriptions.index')" class="w-full text-center font-normal">
                            Upgrade
                        </Link>
                    </jet-button>
                </div>
                
                <div>
                    <div class="flex items-center">
                        <progress-bar
                            :invert="false"
                            :value="organization.current_cycle_usage || 0"
                            :max="organization.current_cycle_limit || 1"
                            class="organization-info-usage-bar"
                        />
                        <p class="organization-info-usage-summary ml-8 text-sm leading-3">
                            Used
                            <span class="font-bold">{{
                                organization.current_cycle_usage || 0
                            }}</span>
                            of {{ organization.current_cycle_limit || 0 }} Credits
                        </p>
                    </div>
                </div>
            </div>

        </div>

      <div v-if="!$page.props.subscribed && $page.props.is_admin" class="mt-7 p-3 md:p-5 md:px-6 bg-gray-200 md:flex justify-between items-center rounded-lg">
        <p class="bold mb-3 md:mr-4 md:mb-0">
          Upgrade your account to get your own phone number and start messaging your contacts.<br/>
          <span class="font-bold">Start for just $29 + a one time carrier registration fee of $19. Cancel anytime.</span><br/>
          <span class="italic text-sm underline"><a href="https://textspot.io/resources/30-day-money-back-guarantee-policy/" target="_blank">Learn about our 30-day money-back guarantee.</a></span>
        </p>
        <div class="text-center">
            <Link :href="route('subscriptions.index')" class="w-full text-center">
                <JetButton>
                    See Plans
                </JetButton>
            </Link>
        </div>
      </div>
    </div>
</template>

<script>
import ProgressBar from "./../components/ProgressBar";
import JetButton from "../Jetstream/Button";
import axios from "axios";

export default {
    name: "OrganizationInfoBox",
    components: { ProgressBar, JetButton },
    mounted() {
        this.getOrganizationInfo();
    },
    data() {
        return {
            organization: {}
        };
    },
    computed: {
        cycleUsePercentage() {
            if (!this.organization.current_cycle_limit) {
                return 0;
            }

            return (
                (this.organization.current_cycle_usage /
                    this.organization.current_cycle_limit) *
                100
            );
        },
        daysLeft() {
            let days = this.$page.props.days_left_in_subscription;
            if (days == -1) {
                return "";
            }
            
            let daysWord = days > 1 ? "days" : "day";

            if (this.$page.props.grace_period) {
                if (days == 0) {
                    return "Cancels today";
                }
                return "Cancels in " + days + " " + daysWord;
            }

            if (this.$page.props.active_trial) {
                if (days == 0) {
                    return "Trial ends today";
                }
                return "Trial ends in " + days + " " + daysWord;
            }

            if (this.$page.props.pause_scheduled) {
                if (days == 0) {
                    return "Pauses today";
                }
                return "Pauses in " + days + " " + daysWord;
            }

            if (this.$page.props.paused) {
                return "Paused";
            }


            return `${days} ${daysWord} left`;
        }
    },
    methods: {
        async getOrganizationInfo() {
            try {
                const res = await axios.get(route("organizations.info"));
                this.organization = res.data;
            } catch(err) {
                console.log(err);
            };
        }
    }
};
</script>

<style>
    .organization-info-usage-bar {
        @apply mb-1 flex-shrink w-full;
    }

    .organization-info-usage-summary {
        white-space: nowrap;
    }
</style>
